import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconImage = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5 8C5 6.34315 6.34315 5 8 5H16C17.6569 5 19 6.34315 19 8V16C19 17.6569 17.6569 19 16 19H8C6.34315 19 5 17.6569 5 16V8ZM8 7C7.44772 7 7 7.44772 7 8V16C7 16.2556 7.09587 16.4887 7.2536 16.6655L13.9596 9.95956C14.3501 9.56904 14.9832 9.56904 15.3738 9.95956L17 11.5858V8C17 7.44772 16.5523 7 16 7H8ZM17 14.4142L14.6667 12.0809L9.74755 17H16C16.5523 17 17 16.5523 17 16V14.4142ZM7.66667 9.66667C7.66667 8.5621 8.5621 7.66667 9.66667 7.66667C10.7712 7.66667 11.6667 8.5621 11.6667 9.66667C11.6667 10.7712 10.7712 11.6667 9.66667 11.6667C8.5621 11.6667 7.66667 10.7712 7.66667 9.66667Z"
        />
      </svg>
    );
  }
);
